<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="750"
    @click:primary="gerarRelatorio"
  >
    <div class="ml-n2 mt-n2">
      <v-checkbox v-model="filtros.fora_de_linha" hide-details class="pb-3">
        <template #label>
          <span class="ml-1 font-15">Produtos fora de linha</span>
        </template>
      </v-checkbox>

      <v-checkbox v-model="filtros.inativo_revenda" hide-details class="pb-3">
        <template #label>
          <span class="ml-1 font-15">Produtos inativos para revenda</span>
        </template>
      </v-checkbox>

      <v-checkbox v-model="filtros.produto_resgatado" hide-details class="pb-4">
        <template #label>
          <div>
            <p class="ma-0 ml-1 font-15">Produtos resgatados</p>
            <p class="ma-0 ml-1 mt-n1 font-12 text-gray-200">
              Última entrada menor ou igual a 90 dias e estoque zerado por 30 dias antes da última entrada.
            </p>
          </div>
        </template>
      </v-checkbox>

      <v-checkbox v-model="filtros.estoque_maior_que_zero" hide-details class="pb-4">
        <template #label>
          <span class="ml-1 font-15">Apenas produtos com saldo de estoque maior que zero</span>
        </template>
      </v-checkbox>
    </div>

    <div class="d-flex align-center">
      <div class="w-33-porcento pr-1">
        <v-autocomplete
          v-model="filtros.primeira_entrada"
          label="Primeira entrada"
          :items="selects.dias"
          item-text="descricao"
          item-value="valor"
          outlined
          multiple
          clearable
          hide-details
          small-chips
          :height="ALTURA_MINIMA_FILTROS_DIAS"
        />
      </div>

      <div class="w-33-porcento px-1">
        <v-autocomplete
          v-model="filtros.ultima_entrada"
          label="Última entrada"
          :items="selects.dias"
          item-text="descricao"
          item-value="valor"
          outlined
          multiple
          clearable
          hide-details
          small-chips
          :height="ALTURA_MINIMA_FILTROS_DIAS"
        />
      </div>

      <div class="w-33-porcento pl-1">
        <v-autocomplete
          v-model="filtros.idade"
          label="Idade dos produtos"
          :items="selects.dias"
          item-text="descricao"
          item-value="valor"
          outlined
          multiple
          clearable
          hide-details
          small-chips
          :height="ALTURA_MINIMA_FILTROS_DIAS"
        />
      </div>
    </div>

    <div class="d-flex align-center mt-4">
      <div class="w-50-porcento pr-1">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-1">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          label="Filial"
          outlined
          hide-details
          multiple
        />
      </div>
    </div>

    <div class="d-flex align-center">
      <div class="w-50-porcento pr-1">
        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          label="Segmentos"
          outlined
          multiple
          hide-details
          class="mt-4"
        />
      </div>

      <div class="w-50-porcento pl-1">
        <SysFornecedorAutocomplete
          v-model="filtros.fornecedores"
          label="Fornecedores"
          outlined
          multiple
          :ids-segmento="filtros.segmentos"
          hide-details
          class="mt-4"
        />
      </div>
    </div>
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import Api from "@/api/api";

export default {
  name: "NoMoving",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete
  },
  data: () => ({
    filtros: {
      estoque_maior_que_zero: true,
      fora_de_linha: true,
      inativo_revenda: true,
      produto_resgatado: false,
      primeira_entrada: [],
      ultima_entrada: [],
      idade: [],
      grupos: [],
      filiais: [],
      segmentos: [],
      fornecedores: [],
    },
    selects: {
      dias: [
        { valor: 1, descricao: '1. Menor que 90 dias'},
        { valor: 2, descricao: '2. Entre 90 e 180 dias'},
        { valor: 3, descricao: '3. Maior que 180 dias'},
      ]
    }
  }),
  computed: {
    ALTURA_MINIMA_FILTROS_DIAS() {
      const {primeira_entrada, ultima_entrada, idade} = this.filtros;
      return Math.max(primeira_entrada.length, ultima_entrada.length, idade.length, 1) * 37;
    }
  },
  methods: {
    gerarRelatorio() {
      const filtros = {
        ...this.filtros,
        estoque_maior_que_zero: this.filtros.estoque_maior_que_zero ? 'S' : 'N',
        fora_de_linha: this.filtros.fora_de_linha ? 'S' : 'N',
        inativo_revenda: this.filtros.inativo_revenda ? 'S' : 'N',
        produto_resgatado: this.filtros.produto_resgatado ? 'S' : 'N',
      };

      Api({
        url: `${this.relatorio.url}`,
        method: 'POST',
        data: filtros,
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', `RELATORIO-NO-MOVING-${this.dataHoje()}.xlsx`);

          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(error => {
          alert('Erro ao gerar o relatório, ' + error);
          console.error('Erro ao gerar o relatório:', error);
        });

      this.DIALOG_ATIVO = false;
    },
    dataHoje() {
      const hoje = new Date();
      const dia = String(hoje.getDate()).padStart(2, '0');
      const mes = String(hoje.getMonth() + 1).padStart(2, '0');
      const ano = hoje.getFullYear();
      return `${dia}-${mes}-${ano}`;
    }
  }
}
</script>

<style scoped>

</style>
